module.exports = __webpack_public_path__ + "static/media/content_info2.ac077628.png";